Ext.define('SA.DraggableCell', {
    constructor({cls, content, xy, offset}) {
        this.offset = offset;

        this.el = document.createElement('div');
        this.el.className = 'sa-draggable-cell ' + cls;

        this.el.append(content);
        document.body.append(this.el);

        this.setMouseXy(xy);
    },

    destroy() {
        this.el.remove();
    },

    getBox() {
        return Ext.util.Region.getRegion(this.el);
    },

    setMouseXy(xy) {
        var x = xy[0] - this.offset[0],
            y = xy[1] - this.offset[1];

        Ext.fly(this.el).setXY([x, y]);
    }
});